import {
  Component,
  Input,
  ViewEncapsulation
} from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LoaderComponent {

  @Input() isVisible = false;

}